import React from "react";

export default function DealsEmptyDocumentsIcon() {
  return (
    <React.Fragment>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M51 10L44 3H11L9 5V55L11 57H49L51 55V10Z"
          fill="white"
          stroke="#222222"
          strokeWidth="2"
        />
        <path d="M20 22H27V24H20V22Z" fill="#222222" />
        <path d="M20 26H39V28H20V26Z" fill="#222222" />
        <path d="M20 30H39V32H20V30Z" fill="#222222" />
        <path d="M20 34H39V36H20V34Z" fill="#222222" />
        <path d="M20 38H31V40H20V38Z" fill="#222222" />
      </svg>
    </React.Fragment>
  );
}
